import { useContext } from 'react'
import { useGetSociogramTeacherAccess } from '@BUP/hooks/Sociogram/teachersData/useGetTeacherAccess'
import { EventsContext } from '@BUP/contexts/EventsContext'
import styles from './sociogram-info-card.module.scss'
import BupSpinner from '@BUP/components/Loading/Spinner'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGraduationCap } from '@fortawesome/free-solid-svg-icons'
import classNames from 'classnames'
import ResultsButton from '../Buttons/results-button'
import ResourcesButton from '../Buttons/resources-button'
import { useTranslation } from 'react-i18next'
import { capitalizeFirst } from '@BUP/utils'

const SociogramResultsCard = ({ sociogramId, survey }) => {
  const i18n = useTranslation()
  const { events } = useContext(EventsContext)
  const currentEvent = events.find(event => event.activityId === sociogramId)
  const { isLoadingTeacherAccess, dataTeacherAccess, errorTeacherAccess } = useGetSociogramTeacherAccess(currentEvent?.id)

  if (isLoadingTeacherAccess) return <BupSpinner />
  if (errorTeacherAccess) return null
  if (!dataTeacherAccess) return null

  const { hasAccess, decision } = dataTeacherAccess
  const deniedAccess = !hasAccess && decision === 'denied'
  const unsetAccess = !hasAccess && decision === 'unset'

  if (unsetAccess) return null

  return (
    <div className={styles.card}>
      <h3
        className={classNames(styles.header_results_title, {
          [styles.header_results_title_disabled]: deniedAccess
        })}
      >
        <FontAwesomeIcon
          icon={faGraduationCap}
          className={classNames(styles.header_results_icon, {
            [styles.header_results_icon_disabled]: deniedAccess
          })}
        />
        {capitalizeFirst(i18n.t('common.resources.sociogram-results.title'))}
      </h3>
      {deniedAccess && (
        <div className={styles.access_message_wrapper}>
          <p>{i18n.t('common.resources.sociogram-teacher-access.actions.read.state.restricted_text')}</p>
        </div>
      )}
      <div className={styles.content_wrapper}>
        <ResultsButton survey={survey} disabled={deniedAccess} />
        <ResourcesButton survey={survey} disabled={deniedAccess} />
      </div>
    </div>
  )
}

export default SociogramResultsCard
